import React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { Navigate } from 'react-router-dom';
import { useOktaAuth } from '@okta/okta-react';
import { toRelativeUrl } from '@okta/okta-auth-js';
import { Button } from '@/ui';
import ZuulLoader from '../../../components/ZuulLoader/ZuulLoader';
import ZuulLogo from '../../../components/ZuulLogo/ZuulLogo';
import { isAuthenticated, isAuthLoading } from '../../../utils/authStateHelpers';
import { cfg } from '../../../runtime-config';

export const OktaLogin = () => {
  const { oktaAuth, authState } = useOktaAuth();

  const login = () => {
    oktaAuth.signInWithRedirect();
  };

  // Show loading while auth state is being determined
  if (isAuthLoading(authState)) {
    return <ZuulLoader text='Checking authentication...' />;
  }

  if (isAuthenticated(authState)) {
    // Retrieve the stored URL after successful login (default to home — a null
    // preLoginUrl would make toRelativeUrl throw and blank the page)
    const preLoginUrl = sessionStorage.getItem('preLoginUrl') || '/';
    sessionStorage.removeItem('preLoginUrl');
    return <Navigate to={toRelativeUrl(preLoginUrl, window.location.origin)} replace />;
  }

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        bgcolor: 'background.default',
      }}
    >
      <Container maxWidth='sm'>
        <Card elevation={8} sx={{ py: 5 }}>
          <CardContent sx={{ textAlign: 'center' }}>
            <Typography variant='h5' component='h2'>
              Login if you dare
            </Typography>
            <ZuulLogo
              variant='stacked'
              title='Zuul'
              sx={{
                mx: 'auto',
                my: 3,
                width: '100%',
                maxWidth: { xs: 150, sm: 200 },
                height: 'auto',
                transition: 'transform 0.2s ease',
                '&:hover': { transform: 'scale(1.05)' },
              }}
            />
            {authState === null ? (
              <ZuulLoader text={'Logging in...'} />
            ) : (
              <Button type='button' onClick={login} color='primary' sx={{ mt: 3 }}>
                Login with Okta
              </Button>
            )}
            <Typography variant='caption' component='div' sx={{ mt: 4, color: 'text.secondary' }}>
              Version: {cfg('BUILD_VERSION') || 'dev'}
            </Typography>
          </CardContent>
        </Card>
        <Typography variant='body2' sx={{ mt: 2, textAlign: 'center', color: 'text.secondary' }}>
          Copyright &copy; What If Media Group
        </Typography>
      </Container>
    </Box>
  );
};
